<template>
  <v-tabs class="sub-menu md-3" slider-color="primary">
    <v-tab class="sub-menu-item" to="/settings/cost-centre" exact>
      {{ $t("settings.costCentre.menu.list") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/cost-centre/users">
      {{ $t("settings.costCentre.menu.userAssignment") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/cost-centre/budget">
      {{ $t("settings.costCentre.menu.budget") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "CostCentreMenu"
};
</script>

<style scoped></style>
